import React from 'react';
import InventorySlot, { InventoryItem } from './InventorySlot';

interface InventoryProps {
  items: Array<InventoryItem | null>;
  columns?: number;
  rows?: number;
  selectedIndex?: number | null;
  onSelect?: (index: number) => void;
  className?: string;
}

const Inventory: React.FC<InventoryProps> = ({
  items,
  columns = 4,
  rows = 7,
  selectedIndex = null,
  onSelect,
  className,
}) => {
  const count = columns * rows;
  const slots = Array.from({ length: count }, (_, index) => items[index] ?? null);

  return (
    <div
      className={className ? `osrs-inventory ${className}` : 'osrs-inventory'}
      style={{ gridTemplateColumns: `repeat(${columns}, 40px)` }}
      role="list"
    >
      {slots.map((item, index) => (
        <div role="listitem" key={index}>
          <InventorySlot
            item={item ?? undefined}
            selected={selectedIndex === index}
            onClick={onSelect ? () => onSelect(index) : undefined}
          />
        </div>
      ))}
    </div>
  );
};

export default Inventory;
